module.exports = "/build/web/svg/sponsor/vdk.f3b69d80e646576cd33280df33351b51.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/sponsor/vdk.svg
// module id = 224
// module chunks = 24